import { Observable } from 'rxjs'
import { map, tap } from 'rxjs/operators'
import { Member } from 'src/app/features/member/member'

import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { environment } from '../../../environments/environment'
import { TokenResponse } from './interfaces'

@Injectable()
export class AuthService {
  private backendUrl: string = `${environment.backendApiUrl}/auth`
  constructor(private http: HttpClient) {}

  public login(email: string, password: string): Observable<TokenResponse> {
    return this.http
      .post<any>(`${this.backendUrl}`, {
        email: email,
        password: password
      })
      .pipe(
        map((data) => {
          return {
            accessToken: data.access_token,
            refreshToken: data.refresh_token,
            idToken: data.id_token,
            expiresIn: data.expires_in,
            scope: data.scope,
            tokenType: data.token_type
          }
        })
      )
  }

  public register(member: Partial<Member>): Observable<TokenResponse> {
    return this.http.post<any>(`${this.backendUrl}/register`, member).pipe(
      map((data) => {
        return {
          accessToken: data.access_token,
          refreshToken: data.refresh_token,
          idToken: data.id_token,
          expiresIn: data.expires_in,
          scope: data.scope,
          tokenType: data.token_type
        }
      })
    )
  }

  public changePassword(pw: string, currentPw = ''): Observable<Member> {
    return this.http.post<any>(`${this.backendUrl}/password`, {
      currentPassword: currentPw,
      password: pw,
      passwordRepeat: pw
    })
  }

  public sendPasswordResetEmail(
    emailAddress: string,
    resetPath: string
  ): Observable<Boolean> {
    return this.http.post<any>(`${this.backendUrl}/reset-password-email`, {
      email: emailAddress,
      resetPath: resetPath
    })
  }

  public tokenRefresh(refreshToken: string): Observable<TokenResponse> {
    return this.http
      .post<any>(`${this.backendUrl}/token-refresh`, {
        refresh_token: refreshToken
      })
      .pipe(
        map((data) => {
          return {
            accessToken: data.access_token,
            refreshToken: data.refresh_token,
            idToken: data.id_token,
            expiresIn: data.expires_in,
            scope: data.scope,
            tokenType: data.token_type
          }
        })
      )
  }

  public getMember(): Observable<Member> {
    return this.http.get<any>(`${this.backendUrl}?ap=0`)
  }

  public updateMember(id: number, params: Partial<Member>): Observable<Member> {
    return this.http.patch<Member>(`${this.backendUrl}/profile`, {
      ...params
    })
  }

  public anonymizeMember(memberId: number): Observable<Member> {
    return this.http.post<any>(`${this.backendUrl}/anonymize`, {
      memberId
    })
  }

  public parseToken(token: string): any | null {
    if (!token) {
      return null
    }

    try {
      return JSON.parse(atob(token.split('.')[1]))
    } catch (error) {
      console.warn('auth service fails to parse token: ', token)
      return null
    }
  }
}
